
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  name: 'UpdateData',
  setup() {
    onMounted(() => {
      document.body.style.backgroundColor = "#633130"
    })
  }
})
